package com.evoapps.evoshift.domain.provider

import com.evoapps.evoshift.domain.model.DevicePlatform

interface DeviceInfoProvider {
    suspend fun getFcmToken(): String?
    fun getDeviceName(): String
    fun getPlatform(): DevicePlatform

    /** The app's language ("pl" or "en"), for e-mails the server sends on the person's behalf. */
    fun getLanguage(): String = "pl"
}
